/* sh-load-more.js — resilient "Laad nog X meer" for collection pages.
 *
 * Self-contained: appends the NEXT page's server-rendered cards via AJAX, with
 * no /data/ dependency and no scroll jump. The collection grid is server-
 * rendered by {% paginate %} in sh-collection.liquid, and native Search &
 * Discovery filtering (sh-collection-filters.js) navigates rather than client-
 * renders, so this module always owns the load-more interaction. The plain
 * {% paginate %} link remains the no-JS fallback.
 */
(function () {
  var grid = document.getElementById('products-grid');
  if (!grid) return;

  var btn = document.querySelector('[data-load-more]') ||
    (grid.parentElement && grid.parentElement.querySelector('a.cta-pill[href*="page="]'));
  if (!btn) return;

  var wrap = btn.closest('[data-load-more-wrap]') || btn.parentElement;
  var iconEl = btn.querySelector('svg');
  var iconHTML = iconEl ? iconEl.outerHTML : '';
  var busy = false;

  function nextButtonIn(doc) {
    return doc.querySelector('[data-load-more]') ||
      doc.querySelector('a.cta-pill[href*="page="]');
  }

  btn.addEventListener('click', function (e) {
    // Let modifier / middle-click open the next page natively (new tab etc).
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    if (busy) return;
    busy = true;
    var url = btn.getAttribute('href');
    btn.setAttribute('aria-busy', 'true');

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.getElementById('products-grid');
        if (nextGrid) {
          var before = grid.children.length;
          grid.insertAdjacentHTML('beforeend', nextGrid.innerHTML);
          // Mark appended cards visible (the global .reveal observer won't see
          // dynamically inserted nodes).
          for (var i = before; i < grid.children.length; i++) {
            var card = grid.children[i];
            card.classList.add('in');
            var nested = card.querySelectorAll ? card.querySelectorAll('.reveal') : [];
            for (var j = 0; j < nested.length; j++) nested[j].classList.add('in');
          }
        }
        // Advance the button to the page-after-next, or hide it when exhausted.
        var nb = nextButtonIn(doc);
        var nbHref = nb && nb.getAttribute('href');
        if (nbHref) {
          btn.setAttribute('href', nbHref);
          var label = btn.querySelector('[data-load-more-label]');
          var nbText = (nb.textContent || '').replace(/\s+/g, ' ').trim();
          if (label) { if (nbText) label.textContent = nbText; }
          else if (nbText) btn.innerHTML = nbText + ' ' + iconHTML;
        } else if (wrap) {
          wrap.classList.add('hidden');
        }
      })
      .catch(function (err) {
        // Never make it worse than the plain link: fall back to navigation.
        if (window.console) console.error('[sh-load-more]', err);
        window.location.href = url;
      })
      .then(function () {
        busy = false;
        btn.removeAttribute('aria-busy');
      });
  });
})();
